import { useMutation } from '@tanstack/react-query';

import type { MutationConfig } from '@/lib/react-query';
import { api, extractData } from '@/lib/treaty';

import type { EnergySchema } from '../schemas/energy';

type UseUpdateEstateEnergy = {
  mutationConfig?: MutationConfig<typeof updateEstateEnergy>;
};

export interface UpdateEstateEnergy extends Omit<EnergySchema, 'validUntil' | 'issuedOn'> {
  id: string;
  validUntil: string;
  issuedOn: string;
}

export const updateEstateEnergy = ({ id, ...args }: UpdateEstateEnergy) => {
  return extractData(api.estates({ id }).energy.put(args));
};

export const useUpdateEstateEnergy = ({ mutationConfig }: UseUpdateEstateEnergy) => {
  return useMutation({
    ...mutationConfig,
    mutationFn: updateEstateEnergy,
  });
};
